<div *ngIf="!easControl.meta.hidden">
  <ng-container *ngIf="showType === 'readOnly' && forceDisplayReadOnly">
    <ng-container [ngSwitch]="easControl.field.widget.type">
      <ng-container *ngSwitchCase="'heading'">
        <h3>{{ easControl.field.title }}</h3>
      </ng-container>
      <ng-container *ngSwitchCase="'paragraph'">
        <p [innerHtml]="easControl.field.options.content"></p>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ub-form-readable label="{{ easControl.field.title }}"
                          value="This field will be visible to the user but not editable"
                          display="block"
                          i18n-value
        >
        </ub-form-readable>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showType === 'readOnly' && $readOnlyVisibility() && !forceDisplayReadOnly">
    <ng-container [ngSwitch]="easControl.field.widget.type">
      <ng-container *ngSwitchCase="'heading'">
        <h3>{{ easControl.field.title }}</h3>
      </ng-container>

      <ng-container *ngSwitchCase="'paragraph'">
        <p [innerHtml]="easControl.field.options.content"></p>
      </ng-container>

      <ng-container *ngSwitchCase="'text'">
        <ub-form-readable label="{{ easControl.field.title }}"
                          display="block">
          <p richText>{{ $readonlyValue() }}</p>
        </ub-form-readable>
      </ng-container>

      <ng-container *ngSwitchCase="'date'">
        <ub-form-readable label="{{ easControl.field.title }}"
                          value="{{ $readonlyValue() | date}}"
                          display="block">
        </ub-form-readable>
      </ng-container>

      <ng-container *ngSwitchCase="'datetime'">
        <ub-form-readable label="{{ easControl.field.title }}"
                          value="{{ $readonlyValue() | date:'medium'}}"
                          display="block">
        </ub-form-readable>
      </ng-container>

      <ng-container *ngSwitchCase="'file'">
        <!--  Ugly but no idea how to do it better -->
        <ub-form-readable label="{{ easControl.field.title }}" display="block">
          <eas-file-upload-control richText
                                   [readonly]="true"
                                   [readonlyValue]="easControl.model">
          </eas-file-upload-control>
        </ub-form-readable>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <ub-form-readable label="{{ easControl.field.title }}"
                          value="{{ $readonlyValue() }}"
                          display="block">
        </ub-form-readable>
      </ng-container>

    </ng-container>
  </ng-container>

  <ng-container *ngIf="showType === 'editable'">
    <div [ngClass]="easControl.field.options?.lockable ? 'actionable' : ''">
      <label *ngIf="['heading', 'paragraph', 'boolean', 'hidden'].indexOf(easControl.field.widget.type) === -1"
        for="{{ easControl.field.id }}">
        <span [ngClass]="{required: easControl.field.options?.required}">
          {{ easControl.field.title }}
        </span>
        <span *ngIf="easControl.field.options?.required">(*)</span>
      </label>
      <div *ngIf="lockable">
        <button (click)="toggleLock()" [attr.aria-label]="locked ? 'Change value for ' + easControl.field.title : 'Use original value for ' + easControl.field.title">{{ locked ? 'Change value' : 'Use original value' }}</button>
        <app-badge [attr.id]="easControl.field.id + '-value-description'" *ngIf="!locked" variant="warning" title="Value changed"></app-badge>
        <app-badge [attr.id]="easControl.field.id + '-value-description'" *ngIf="locked" variant="info" title="Value unchanged"></app-badge>
      </div>
    </div>
    <eas-easform-control-single [easControl]="easControl"></eas-easform-control-single>
    <p [attr.id]="easControl.field.id + '-change-description'" class="change-info" *ngIf="lockable && locked">
      To change the value and overwrite all existing values, select <strong>Change value</strong>.
    </p>
    <p [attr.id]="easControl.field.id + '-change-description'" class="change-alert" *ngIf="lockable && !locked">
      Changing the <strong>{{ easControl.field.title }}</strong> value will overwrite all existing values with your new value. To revert this change and use the original value, select <strong>Use original value</strong>.
    </p>
  </ng-container>

</div>
